import React from 'react';


export default class HomeComponent extends React.Component {

	render() {
		return (
			<div>
				台灣開廣紡纖系統首頁
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/HomeComponent.jsx